export default __webpack_public_path__ + "static/Rocket_Launcher-79c25636afcadb3672c2a52b77ab722c.png";